import type { FormInstance } from '@arco-design/web-react';

import { VendorDeviceSelector } from '../resourceConfig/VendorDeviceSelector';
import { VendorDevicePersistFields } from './VendorDevicePersistFields';
import { DISK_PRICING_FIELD } from './types';
import { syncPricingDeviceToStorageClass } from './utils';

interface DiskPricingVendorDeviceFieldsProps {
  form: FormInstance;
  billModelId: string;
  /** 交付类型 id，计价 resolve 必传 */
  deploymentTypeId?: string;
  resourceCode: string;
  fieldPrefix?: string;
  /** 计价选中厂商设备后，将 deviceID 写入该 form 字段（通常为 storageClass；展示名走 optionMeta） */
  storageClassField?: string;
  disabled?: boolean;
  /** 不请求厂商设备列表；默认与 disabled 一致 */
  skipFetch?: boolean;
}

/** 磁盘创建弹窗：计价场景展示厂商设备列表，存储类字段隐藏并由 deviceID 回填 */
export function DiskPricingVendorDeviceFields({
  form,
  billModelId,
  deploymentTypeId,
  resourceCode,
  fieldPrefix = DISK_PRICING_FIELD,
  storageClassField,
  disabled,
  skipFetch,
}: DiskPricingVendorDeviceFieldsProps) {
  return (
    <>
      <VendorDeviceSelector
        form={form}
        resourceCode={resourceCode}
        vendorDevicePrefix={fieldPrefix}
        billModelId={billModelId}
        deploymentTypeId={deploymentTypeId}
        disabled={disabled}
        skipFetch={skipFetch}
        onPricingSelectionChange={(selection) => {
          if (storageClassField) {
            syncPricingDeviceToStorageClass(form, selection, storageClassField);
          }
        }}
      />
      <VendorDevicePersistFields fieldPrefix={fieldPrefix} />
    </>
  );
}
